export default function Home() {
  return (
    <section className="hero">
      <h1>Find games you can actually play together.</h1>
      <p>
        Tell us your console, your genre, and whether you're playing with
        friends — we'll pick a game.
      </p>
      <div className="hero-cta">
        <a className="cta" href="#/recommend">
          Recommend me a game →
        </a>
        <a className="cta cta-secondary" href="#/browse">
          Browse the catalog
        </a>
      </div>
    </section>
  );
}
